import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import AnchorLink from "../components/AnchorLinkComponent";
import ReactDOM from "react-dom";
import ProjectRescueService from '../Services/ProjectRescueServices';


class ProjectManagementService extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (
            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Project Management Services</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have managed teams of anywhere from two to sixty developers. Those have been both widely scattered remote teams and in-house at my clients sites. I have managed projects using "extreme", "agile" and old fashioned "waterfall" methodologies.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>My management services can include whatever aspect my client desires:
                            <ul >
                                <li>Needs Assessment</li>
                                <li>Product Design</li>
                                <li>Project Planning</li>
                                <li>Team Creation and Recruiting</li>
                                <li>Process Development</li>
                                <li>Project Execution, Monitoring and Control</li>
                                <li>Test Design and Quality Control</li>
                                <li>Product Closure</li>
                            </ul>
                        </p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>If you have a project in distress I can help you <AnchorLink value="rescue" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/services/projectrescue'/> it.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectManagementService



// WEBPACK FOOTER //
// src/Services/ProjectManagementServices.js